<template>
	<v-form ref="form">
		<v-row no-gutters>
			<v-col cols="6">
				<v-text-field
					filled
					v-model="variable.name"
					:placeholder="$gettext('Name')"
					hide-details
          :rules="[required]"
				></v-text-field>
			</v-col>
			<v-col cols="12" class="mt-4 mb-2">
				<span class="text-subtitle-1"><translate>Options</translate></span>
			</v-col>
			<v-col cols="12">
				<v-btn fab color="primary" @click="showNewOption = !showNewOption" small>
					<v-icon>mdi-plus</v-icon>
				</v-btn>
			</v-col>
			<v-row no-gutters v-if="showNewOption" align="center" class="mt-3">
				<v-col cols="6">
          <v-form ref="newOptionForm">
            <v-text-field
              filled
              v-model="newOption.name"
              :placeholder="$gettext('Option Name')"
              hide-details
              :rules="[required]"
            ></v-text-field>
          </v-form>
				</v-col>
				<v-col>
					<v-btn color="primary" @click="addOption" small class="ml-2">
						<translate>Add</translate>
					</v-btn>
				</v-col>
			</v-row>
			<v-col cols="12" class="mt-4">
				<p v-if="variable.options.length == 0" class="font-weight-thin ml-2" v-translate>No options.</p>
				<v-list v-else>
					<v-list-item
						v-for="(option, i) in variable.options"
						:key="i"
						style="border: 1px solid #e0e0e0; border-radius: 5px"
					>
						<v-list-item-content>
							<v-list-item-title>
								<template v-if="option.edit">
									<v-text-field
										filled
										v-model="option.name"
										:placeholder="$gettext('Option Name')"
										hide-details
										:rules="[required]"
									></v-text-field>
								</template>
								<template v-else>
									{{ option.name }}
								</template>
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-action>
							<v-row no-gutters>
								<v-btn color="primary" icon small @click="option.edit = !option.edit">
									<v-icon color="primary" small>mdi-pencil</v-icon>
								</v-btn>
								<v-btn color="primary" icon small @click="deleteOption(option)">
									<v-icon color="primary" small>delete</v-icon>
								</v-btn>
							</v-row>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</v-col>
		</v-row>
	</v-form>
</template>

<script>
export default {
	name: "VariableForm",
	props: ["variable"],
	data: () => ({
		showNewOption: false,
		newOption: {
      id: -1,
			name: ""
		},
	}),
	computed: {
		required() {
			return (value) => !!value || this.$gettext("Required.");
		},
	},
	methods: {
		addOption() {
      if(this.$refs.newOptionForm.validate()) {
        let option = {};
        option.name = this.newOption.name;
        option.edit = false;
        this.variable.options.push(option);
        this.newOption.name = "";
        this.$refs.newOptionForm.reset()
      }
		},
		deleteOption(option) {
			this.variable.options.splice(this.variable.options.indexOf(option), 1);
		},
		validate() {
			return this.$refs.form.validate();
		},
	},
	created() {
		for (let i = 0; i < this.variable.options.length; i++) {
			this.$set(this.variable.options[i], "edit", false);
		}
	}
};
</script>